import { FC, PropsWithChildren } from "react";
import Navigation from "components/layout/Navigation";
import logo from "assets/gtc-logo.png";
import { Space } from "antd";
import VenueContextSelect from "components/data/VenueSelect/VenueContextSelect";

import * as Styled from "./styles";

const MainTemplate: FC<PropsWithChildren> = ({ children }) => (
  <Styled.MainTemplate>
    <Styled.Sidebar>
      <Styled.LogoWrapper>
        <Styled.Logo src={logo} />
      </Styled.LogoWrapper>
      <Styled.VenueSelectWrapper>
        <VenueContextSelect />
      </Styled.VenueSelectWrapper>
      <Navigation />
    </Styled.Sidebar>
    <Space />
    <Styled.Main>
      <Styled.Content>{children}</Styled.Content>
    </Styled.Main>
  </Styled.MainTemplate>
);

export default MainTemplate;
